import React from 'react';
import {
    Segment,
    Table,
    Header,
    Form,
    Button,
    Select,
    Input
} from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { ToastContainer, toast } from 'react-toastify';
import { validate } from 'react-email-validator';


/* props:
editMode bool, contactTypes array, onAddNewContact fn, onDeleteContact fn, contacts array
*/

// in student create, contacts are added and changed locally, so onAddNewContact and onDeleteContact
// need to append their own ids for this component to know on which contacts to call delete.
export default class ContactFormSegment extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            editContactMode: false,
            newContact: {
                contactTypeId: null,
                value: '',
            },
            newEditedContact: '',
            id: '',

            contactTypeErr: false,
            valueErr: false

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.onAddNewContact = this.onAddNewContact.bind(this);
        this.onEditContact = this.onEditContact.bind(this);
        this.editContact = this.editContact.bind(this);
    }

    onAddNewContact() {
        const { newContact } = this.state;
        let { text } = this.props.contactTypes.find(el => el.key === newContact.contactTypeId);

        if (!newContact.contactTypeId || !newContact.value) {
            toast('Niste unijeli sva obavezna polja.');
            if (!newContact.value) { this.setState({ valueErr: true }); } else { this.setState({ valueErr: false }); }
            if (!newContact.contactTypeId) { this.setState({ contactTypeErr: true }); } else { this.setState({ contactTypeErr: false }); }
        } else if ((text === 'primarni e-mail' || text === 'e-mail') && !validate(newContact.value)) {
            toast('E-mail adresa nije unesena u pravilnom formatu!');
        } else {
            this.setState({ valueErr: false, contactTypeErr: false });
            const createdContact = {
                contactTypeId: newContact.contactTypeId,
                value: newContact.value,
            };
            this.props.onAddNewContact(createdContact);

            this.setState(prevState => ({
                newContact: {
                    contactTypeId: '',
                    value: '',
                },
                id: ''
            }));
        }
    }

    editContact(id, value) {
        if (id === this.state.editContactMode) {
            this.setState({ editContactMode: null });
        } else {
            this.setState({ editContactMode: id, newEditedContact: value });
        }
    }

    onEditContact(id, optLock, type) {
        let { text } = this.props.contactTypes.find(el => el.text === type);
        const createdContact = {
            id,
            value: this.state.newEditedContact,
            optLock
        };
        if ((text === 'primarni e-mail' || text === 'e-mail') && !validate(this.state.newEditedContact)) {
            toast('E-mail adresa nije unesena u pravilnom formatu!');
        } else {
            this.props.onEditContact(createdContact);
            this.setState({ editContactMode: false });
        }
    }

    getContactTypeName(id) {
        const typeObj = this.props.contactTypes.find(el => el.value === id);
        if (typeObj && typeObj.text) return typeObj.text;
        return null;
    }
    handleInputChange(e, { name, value }) {
        this.setState({ newContact: { ...this.state.newContact, [name]: value } });
    }
    render() {
        return (
            <React.Fragment>
                { this.props.contacts.length ? <div className={!this.props.noSegment && 'ui clearing segment'}>
                    <Table compact size="small" celled unstackable>
                        <Table.Body>
                            {this.props.contacts.map(el =>
                                (<Table.Row key={el.id}>
                                    <Table.Cell textAlign="right" >
                                        <b>{el.type}</b>
                                    </Table.Cell>
                                    {this.state.editContactMode === el.id ?
                                        <Table.Cell>
                                            <Form size="mini">
                                                <Form.Field >
                                                    <input
                                                        value={this.state.newEditedContact}
                                                        onChange={(e) => this.setState({ newEditedContact: e.target.value })}
                                                        name="input"
                                                    />
                                                </Form.Field>
                                            </Form>
                                        </Table.Cell>
                                        :
                                        <Table.Cell>
                                            {el.value}
                                        </Table.Cell>

                                    }{this.props.createNewStudent && <Table.Cell>
                                        <Button
                                            basic="true"
                                            circular
                                            icon="trash alternate"
                                            size="mini"
                                            onClick={() => { this.props.onDeleteContact(el.value, el.type); }}
                                        />
                                    </Table.Cell>}

                                    {((this.props.editMode && !this.state.editContactMode && !this.props.createNewStudent && this.props.main) || (this.props.contactEditMode && !this.state.editContactMode)) && <Table.Cell textAlign="center">

                                        <Button
                                            basic="true"
                                            circular
                                            icon="pencil"
                                            size="small"
                                            color="green"
                                            onClick={() => this.editContact(el.id, el.value)}
                                        />
                                        <Button
                                            basic="true"
                                            circular
                                            icon="trash alternate"
                                            size="small"
                                            color="red"
                                            onClick={() => this.props.onDeleteContact(el.id)}
                                        />
                                    </Table.Cell>}
                                    {this.state.editContactMode === el.id && <Table.Cell textAlign="center">
                                        <Button
                                            size="small"
                                            color="blue"
                                            circular
                                            icon="check"
                                            onClick={() => this.onEditContact(el.id, el.optLock, el.type)}
                                        />
                                        <Button
                                            size="small"
                                            basic="true"
                                            color="blue"
                                            circular
                                            icon="close"
                                            onClick={() => this.editContact(el.id, el.value)}
                                        />

                                    </Table.Cell>
                                    }

                                </Table.Row>))}
                        </Table.Body>
                    </Table>
                </div> : <Segment><FormattedMessage id="student.noContactInfo" /></Segment>}
                {this.props.noSegment && <br />}
                { (this.props.main || this.props.contactEditMode || this.props.createNewStudent) ?
                    (this.props.editMode || this.props.contactEditMode) && <div className={!this.props.noSegment && 'ui clearing segment'}>
                        {(!this.props.hr) && <Header as="h5"><FormattedMessage id="student.addNewContact" /></Header>}
                        <Form noValidate>
                            <Form.Group widths="equal">
                                <Form.Field
                                    fluid
                                    required
                                    error={this.state.contactTypeErr}
                                    control={Select}
                                    clearable
                                    value={this.state.newContact.contactTypeId}
                                    options={this.props.contactTypes}
                                    placeholder="Tip kontakta"
                                    onChange={this.handleInputChange}
                                    name="contactTypeId"
                                />
                                <Form.Field
                                    fluid
                                    required
                                    error={this.state.valueErr}
                                    control={Input}
                                    onChange={this.handleInputChange}
                                    placeholder="Vrijednost"
                                    value={this.state.newContact.value}
                                    name="value"
                                />
                                {!this.props.noSegment && <Button className="d-md-down-none" primary floated="right" onClick={this.onAddNewContact}><FormattedMessage id="common.add" /></Button>}
                                {/* for mobile */}
                                <Form.Field className="d-lg-none" > {!this.props.noSegment && <Button primary floated="right" onClick={this.onAddNewContact}><FormattedMessage id="common.add" /></Button>}</Form.Field>

                            </Form.Group>
                        </Form>
                        {this.props.noSegment && <Button primary floated="right" onClick={this.onAddNewContact}><FormattedMessage id="common.add" /></Button>}

                    </div> : null}
                {/* <ToastContainer hideProgressBar /> */}
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/util/ContactFormEditable.js